import { render, staticRenderFns } from "./dyAuthSuccess.vue?vue&type=template&id=31f1bca2&scoped=true"
import script from "./dyAuthSuccess.vue?vue&type=script&lang=js"
export * from "./dyAuthSuccess.vue?vue&type=script&lang=js"
import style0 from "./dyAuthSuccess.vue?vue&type=style&index=0&id=31f1bca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1bca2",
  null
  
)

export default component.exports